<ng-container *ngIf="!loading; else loadingTpl">



  <div class="container-fluid p-4">

    <div fxLayout="row" fxLayout.lt-sm="column" class="mb-4 gap-3">

      <div fxFlex="nogrow" class="testbed-selector-container">
        <mat-form-field appearance="outline" class="w-100 dense-form-field">
          <mat-label>Selected Testbed</mat-label>
          <mat-select
            [(value)]="selectedTestbed"
            placeholder="Choose a testbed..."
            (selectionChange)="onSelectTestbed($event.value)">
            <mat-option *ngFor="let t of testbeds" [value]="t">
              {{ t.identifier }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="!selectedTestbed" class="empty-state-container">
      <mat-icon class="large-icon text-muted">settings_input_component</mat-icon>
      <h3 class="text-muted mt-2">Please select a Testbed to configure Boxes.</h3>
    </div>

    <div *ngIf="selectedTestbed">

      <div *ngIf="boxes?.length === 0" class="empty-state-container p-5 border-dashed">
        <p class="text-muted">This testbed has no boxes yet.</p>
      </div>

      <mat-accordion multi="false" class="box-accordion">

        <mat-expansion-panel *ngFor="let box of boxes" class="mb-1 mat-elevation-z2 square-panel"
                             (afterExpand)="loadSutBoxInterfaces(box)">

          <mat-expansion-panel-header>
            <mat-panel-title fxLayout="row" fxLayoutAlign="start center">
              <mat-icon class="mr-2 text-primary">dns</mat-icon>
              <span class="box-title">{{ box.identifier || 'Unnamed Box' }}</span>
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center" *ngIf="box.sutInterfaces">
              {{ box.sutInterfaces?.length || 0 }} Interfaces
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="pt-3">

            <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-2_5">
              <h3 class="mat-h3 m-0">Network Interfaces</h3>
              <button mat-stroked-button color="primary" (click)="addInterface(box)" [disabled]="hasEmptyInterface(box)"
                      class="small-btn">
                + Add Interface
              </button>
            </div>

            <div class="interfaces-container bg-light p-3 rounded-square mb-4">

              <div *ngIf="box.sutInterfaces?.length === 0" class="text-center text-muted py-3">
                <small>No interfaces configured yet.</small>
              </div>

              <div *ngFor="let int of box.sutInterfaces; let i = index"
                   class="interface-row mb-2"
                   fxLayout="row"
                   fxLayout.lt-md="column"
                   fxLayoutGap="16px"
                   fxLayoutAlign="start center">

                <mat-form-field appearance="outline" fxFlex="30" fxFlex.lt-md="100" class="bg-white dense-form-field">
                  <mat-label>Interface name (e.g. eth0)</mat-label>
                  <input matInput [(ngModel)]="int.ifName" required>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex fxFlex.lt-md="100" class="bg-white dense-form-field">
                  <mat-label>Type</mat-label>
                  <mat-select [(ngModel)]="int.qualifiedName">
                    <mat-option *ngFor="let iface of sutBoxInterfacesTypes" [value]="iface.qualifiedName">
                      {{iface.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <button mat-icon-button color="warn" (click)="removeInterface(box, i)" matTooltip="Remove interface">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px" class="pt-2">

              <mat-progress-spinner *ngIf="saving" diameter="16" mode="indeterminate"></mat-progress-spinner>
              <button mat-flat-button color="primary" (click)="saveBox(box)"
                      [disabled]="saving || !isBoxValid(box)" class="px-4">
                <mat-icon class="mr-2">save</mat-icon>
                Save Configuration
              </button>
            </div>

          </div>
        </mat-expansion-panel>
      </mat-accordion>

    </div>
  </div>
</ng-container>

<ng-template #loadingTpl>
  <div class="spinnerContainer" fxLayout="column" fxLayoutAlign="center center" style="height: 300px;">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="mt-3 text-muted">Loading configuration...</p>
  </div>
</ng-template>
